import React from "react";
import { User } from "../user/userApi";

type ProfileJumbotronProps = {
  user: User;
  isLoggedIn: boolean;
  children?: React.ReactNode;
};

export const ProfileJumbotron = ({
  user,
  isLoggedIn,
  children,
}: ProfileJumbotronProps): JSX.Element => {
  return (
    <>
      <div className="max-w-screen-xl px-4 py-8 mx-auto sm:px-6 lg:px-8">
        {isLoggedIn && user ? (
          <div className="mt-8">
            <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">
              Welcome Back, {!user.first_name ? user.username : user.first_name}
              !
            </h1>
            <p className="mt-1.5 text-sm text-gray-500">
              You can pick up your previous task from the list 🗒️.
              Alternatively, you can start new tasks by checking out the
              notification icon! 🔔
            </p>
          </div>
        ) : null}
      </div>
      {children}
    </>
  );
};
